module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-36.f0ea3844.png";